import {FormikProps} from 'formik';
import {useState} from 'react';
import ImageCropper from '../../../components/ImageCropper';
import {ShowFormError} from '../../../utilities/helper/showFormError';
import {IBrandForm} from './BrandFormData';

interface IProps {
  form?: FormikProps<IBrandForm>;
}

const BrandLogoUpload = ({form}: IProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleCropComplete = (croppedImage: File) => {
    form?.setFieldValue('logo', croppedImage);

    // Create preview URL
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result as string);
    };
    fileReader.readAsDataURL(croppedImage);
  };

  const handleRemoveImage = () => {
    setPreviewUrl(null);
    if (form) {
      form.setFieldValue('logo', null);
    }
  };

  return (
    <section>
      <p className="mb-3 color-gray-1 text-md font-medium">
        تصویر لوگوی برند<span className="text-red-500">*</span>
      </p>

      <div className="flex flex-col">
        {previewUrl ? (
          <div className="mb-3 relative">
            <img
              src={previewUrl}
              alt="Brand Logo Preview"
              className="w-20 h-20 object-contain rounded-xl border-[2px] border-dashed"
            />
            <button
              type="button"
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
              onClick={handleRemoveImage}
            >
              ×
            </button>
          </div>
        ) : (
          <ImageCropper onCropComplete={handleCropComplete} />
        )}
        <ShowFormError field="logo" form={form} />
      </div>
    </section>
  );
};

export default BrandLogoUpload;
